import React, { useEffect, useState } from "react";
import { Box, Grid, TextField, Button, IconButton } from "@mui/material";
import TableN from "../../reusableComponents/components/generics/TableN";
import { useTranslation } from "react-i18next";
import {
  fetchFosaFacilityUserPositions,
  fetchFosaFacilityUserSpecialties,
  fetchMedicalStaffInsureeByFilter,
  fetchPolicyholderInsureePicker,
  GetInsuresByHealthFacility,
} from "../../action";
import { useDispatch, useSelector } from "react-redux";
import { getPolicyholderId } from "../../utils/helper";
import EditIcon from "@mui/icons-material/Edit";
import VpnKeyOffOutlinedIcon from "@mui/icons-material/VpnKeyOffOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import AssignPermissionsDialog from "../../components/staffManagement/AssignPermissionsDialog";
import MedicalStaffDialog from "../../components/staffManagement/MedicalStaffDialog";
import MedicalStaffFilter from "../../components/staffManagement/MedicalStaffFilter";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import { MEDICAL_STAFF_DESIGNATION } from "../../utils/constant";
import { useConvention } from "../../hooks/useConvention";

const MedicalStaff = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState(null);
  const [startCursors, setStartCursors] = useState(null);
  const [reload, setReload] = useState(false);
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [userPermission, setUserPermission] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isPermission, setIsPermission] = useState(false);

  const { isConventionnementActive } = useConvention();

  const dispatch = useDispatch();
  const HfInsuree = useSelector((state) => state?.fosaReducer?.HfInsuree);

  const medicalData = useSelector((state) => state?.fosaReducer);
  const SignInSuccess = useSelector((state) => state);
  const hf_Uuid =
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees?.[0]?.uuid;
  const healthData =
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];

  const fosaHealthFacilityPositionItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilityPositionItems;

  const fosaHealthFacilitySpecialtyItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilitySpecialtyItems;

  useEffect(() => {
    if (!fosaHealthFacilityPositionItems) {
      dispatch(fetchFosaFacilityUserPositions());
    }
  }, [dispatch, fosaHealthFacilityPositionItems]);

  useEffect(() => {
    if (!fosaHealthFacilitySpecialtyItems) {
      dispatch(fetchFosaFacilityUserSpecialties());
    }
  }, [dispatch, fosaHealthFacilitySpecialtyItems]);

  const showSnackbar = medicalData?.createFosaUserData;

  useEffect(() => {
    if (showSnackbar) {
      if (showSnackbar?.updateFosaUser) {
        if (!!showSnackbar?.updateFosaUser?.success) {
          setSnackbarMessage(showSnackbar?.updateFosaUser?.message);
        } else {
          setSnackbarMessage(
            t("Failed to done any action on staff management")
          );
        }
        setSnackbarSeverity(
          !!showSnackbar?.updateFosaUser?.success ? "success" : "error"
        );
      } else if (showSnackbar?.updateDesignation) {
        if (showSnackbar?.updateDesignation?.success) {
          setSnackbarMessage(t("Fosa User Designation Updated Sucesfully"));
        } else {
          setSnackbarMessage(
            t("Failed to done any action on staff management")
          );
        }
        setSnackbarSeverity(
          !!showSnackbar?.updateDesignation?.success ? "success" : "error"
        );
      } else {
        if (!!showSnackbar?.createFosaUser?.success) {
          setSnackbarMessage(showSnackbar?.createFosaUser?.message);
        } else {
          setSnackbarMessage(
            t("Failed to done any action on staff management")
          );
        }
        setSnackbarSeverity(
          !!showSnackbar?.createFosaUser?.success ? "success" : "error"
        );
      }
      setSnackbarOpen(true);
    }
  }, [showSnackbar]);

  const handleSnackbarClose = async (event, reason) => {
    // window.location.reload();
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  // const handleChange = (event, newValue) => {
  //   setSelectedTab(newValue);
  // };
  const { t } = useTranslation();
  const headers = () => {
    var h = [
      t("camuNo"),
      t("firstName"),
      t("lastName"),
      t("Employee No."),
      t("designation"),
      t("specialty"),
      t("Action"),
      t(""),
    ];

    return h;
  };
  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }

    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    // if (!!state.isDeleted) {
    params.push(`isDeleted: false`);
    // }
    if (!!state.policyHolderId) {
      params.push(`policyHolder_Code: "${state.policyHolderId}"`);
    }
    return params;
  };

  useEffect(() => {
    if (hf_Uuid) {
      dispatch(GetInsuresByHealthFacility(hf_Uuid));
    }
  }, [hf_Uuid]);

  const policyholderIdMedical = localStorage.getItem("policyholderId");

  const params = buildQueryParams({
    filters: {},
    orderBy: "date_created",
    pageSize,
    beforeCursor: endCursors,
    afterCursor: startCursors,
    policyHolderId: policyholderIdMedical,
  });

  useEffect(() => {
    if (policyholderIdMedical || healthData) {
      let jsonObject;
      if (healthData?.jsonExt) {
        jsonObject = JSON.parse(healthData?.jsonExt);
      }

      const camuCode = jsonObject?.camuCode;

      const params = buildQueryParams({
        filters: {},
        orderBy: "date_created",
        pageSize,
        beforeCursor: endCursors,
        afterCursor: startCursors,
        policyHolderId: policyholderIdMedical || camuCode,
      });
      //dispatch(fetchMedicalStaffInsureeByFilter(params));
    }
  }, [
    dispatch,
    policyholderIdMedical,
    page,
    pageSize,
    healthData,
    endCursors,
    startCursors,
  ]);

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
    setEndCursors(null);
    setStartCursors(null);
  };

  const handleDialogClose = () => {
    setUserDetails(null);
    setUserPermission(false);
  };

  // const handleRowDoubleClick = (rowData) => {
  //   navigate(`${PORTAL_CONTRACT}/:id=${decodeId(rowData.id)}`);
  // };

  const handleEdit = (details) => {
    setShowUpdateDialog(true);
    setRowData(details);
  };

  const handleUser = (details) => {
    // if (details?.user) {
    //   setIsPermission(true)
    // } else {
    //   setIsPermission(false)
    // }

    setUserPermission(true);
    setUserDetails(details);
  };

  useEffect(() => {
    setPageInfo(medicalData?.medicalInsureePageInfo?.totalCount);
    setStartCursors(medicalData?.medicalInsureePageInfo?.endCursor);
    setEndCursors(medicalData?.medicalInsureePageInfo?.startCursor);
  }, [medicalData]);

  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };

  const itemFormatters = () => {
    const result = [
      (medical) =>
        !!(medical?.insuree.camuNumber || medical?.insuree?.chfId)
          ? medical?.insuree.camuNumber || medical?.insuree?.chfId
          : "",
      (medical) =>
        !!medical?.insuree.otherNames ? medical?.insuree.otherNames : "",
      (medical) =>
        !!medical?.insuree.lastName ? medical?.insuree.lastName : "",
      (medical) =>
        !!medical?.insuree.camuNumber ? medical?.insuree.camuNumber : "",
      (medical, index) => (!!medical ? getPosition(medical) : ""),
      (medical, index) => (!!medical ? getSpeciality(medical) : ""),
      (medical) => (
        <IconButton onClick={() => handleEdit(medical)}>
          <EditIcon />
        </IconButton>
      ),
    ];
    result.push((medical) => {
      return !!medical?.user && !!medical?.insuree.camuNumber ? (
        <IconButton onClick={() => handleUser(medical)}>
          <VpnKeyOffOutlinedIcon color="error" />
        </IconButton>
      ) : (
        !!medical?.insuree?.camuNumber && (
          <IconButton onClick={() => handleUser(medical)}>
            <VpnKeyOutlinedIcon
              style={{
                visibility: medical?.id === hoveredRowId ? "visible" : "hidden",
              }}
            />
          </IconButton>
        )
      );
    });
    return result;
  };

  const getPosition = (item) => {
    const jsonExt =
      item?.insuree?.policyholderinsureeSet?.edges?.[0]?.node?.jsonExt;
    if (jsonExt) {
      try {
        const parsedData = JSON.parse(jsonExt);
        const position = fosaHealthFacilityPositionItems.find(
          (item) => item.id === parsedData?.position_id
        );
        if (position) {
          return position.designation;
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
    return "";
  };

  const getSpeciality = (item) => {
    const jsonExt =
      item?.insuree?.policyholderinsureeSet?.edges?.[0]?.node?.jsonExt;
    if (jsonExt) {
      try {
        const parsedData = JSON.parse(jsonExt);
        const position = fosaHealthFacilitySpecialtyItems.find(
          (item) => item.id === parsedData?.speciality_id
        );
        if (position) {
          return position.designation;
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
    return "";
  };

  return (
    <Box>
      <MedicalStaffFilter />
      <Box sx={{ marginTop: 2 }}>
        <TableN
          headers={headers()}
          // headerActions={headerActions}
          itemFormatters={itemFormatters()}
          items={
            (!!medicalData?.medicalInsureeResponseData &&
              medicalData?.medicalInsureeResponseData) ||
            (HfInsuree &&
              HfInsuree.filter((item) => {
                const jsonExt =
                  item.policyholderinsureeSet?.edges?.[0]?.node?.jsonExt;
                if (jsonExt) {
                  try {
                    const parsedData = JSON.parse(jsonExt);

                    

                    if (
                      parsedData?.position_id &&
                      fosaHealthFacilityPositionItems &&
                      fosaHealthFacilityPositionItems.find(
                        (item) => item.id === parsedData?.position_id
                      )?.isHealthProfessional
                    ) {
                      return true;
                    }
                    return false;
                  } catch (error) {
                    console.error("Error parsing JSON:", error);
                  }
                }
                return false;
              }).map((item) => ({ insuree: item }))) ||
            []
          }
          withSelection={"single"}
          withPagination={true}
          rowsPerPageOptions={[10, 50, 100]}
          defaultPageSize={5}
          page={page}
          pageSize={pageSize}
          count={pageInfo}
          onChangePage={(event, newPage) => {
            setPage(newPage);
            handleNavigation(newPage > page ? "forward" : "backward");
          }}
          onChangeRowsPerPage={handleRowsPerPageChange}
          onRowHover={(row) => setHoveredRowId(row.id)}
          onRowLeave={() => setHoveredRowId(null)}
        />
      </Box>
      {!!userPermission && (
        <AssignPermissionsDialog
          open={userPermission}
          onClose={handleDialogClose}
          initialValues={userDetails}
          params={params}
          isPermission={isPermission}
        />
      )}
      {!!showUpdateDialog ? (
        <MedicalStaffDialog
          setShowUpdateDialog={setShowUpdateDialog}
          showUpdateDialog={showUpdateDialog}
          rowData={rowData}
          params={params}
        />
      ) : (
        ""
      )}
      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Box>
  );
};

export default MedicalStaff;
